import { size as _size } from 'lodash-es';
import { dbGuestEvents, dbGuest } from 'dbServer/collections';
import { USER_SESSION_STATUS } from 'store/constants';

export const fetchGuestDetails = async (email, phoneNumber) => {
	const guestUser = await dbGuest.findGuestUser(email, phoneNumber);
	return !_size(guestUser) ? [] : guestUser;
};

export const addGuestUser = async guestInfo => {
	const guestUser = await dbGuest.doCreateGuestUser(guestInfo);
	return !_size(guestUser) ? [] : guestUser;
};

export const updateGuestUser =  (guestId, guestInfo) => {
	return dbGuest.doUpdateGuestUser(guestId, guestInfo);
};

export const guestAlreadyRegisteredToSession = async (guestId, eventId) => {
	const guestSessionDetails = await dbGuestEvents.getGuestUserSession(guestId, eventId);
	return guestSessionDetails;
};

export const registerGuestUserToSession = async (guestId, eventId, data) => {
	const guestRegisteredSession = await dbGuestEvents.registerGuestUserSession(guestId, eventId, {
		status: USER_SESSION_STATUS.REGISTERED,
		registeredDate: new Date().toUTCString()
	});
	return !_size(guestRegisteredSession) ? [] : guestRegisteredSession;
};

export const unregisterGuestUserToSession = async (guestId, eventId, data) => {
	const unregisteredGuestSession = await dbGuestEvents.registerGuestUserSession(guestId, eventId, {
		status: USER_SESSION_STATUS.CANCELLED,
		cancelledDate: new Date().toUTCString()
	});
	return !_size(unregisteredGuestSession) ? [] : unregisteredGuestSession;
};

export const addGuestUserSessionFeedback = async (guestId, eventId, feedback) => {
	const guestUserSessionFeedback = await dbGuestEvents.updateGuestUserSessionFeedback(guestId, eventId, {
		...feedback,
		feedbackDate: new Date().toUTCString()
	});
	return !_size(guestUserSessionFeedback) ? [] : guestUserSessionFeedback;
};
